'use strict';
// 54916
$('.user-testimonial-carousel').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1
});

setTimeout(function () {
    $(".user-testimonial-carousel").addClass('carousel-initialized');
}, 500);


var totSlide = $('.user-testimonial-carousel').slick("getSlick").slideCount;
function removeSlide() {
    return ($(".user-testimonial-carousel").slick("getSlick").slideCount - 1);
}

if (totSlide > 6) {
    for (var i = 6; i < totSlide; i++) {
        $('.user-testimonial-carousel').slick('slickRemove', removeSlide());
    }
}

// 76753 Recently Viewed Carousel

$('.product-tiles-recent__list').slick({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    infinite: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                arrows: false,
                dots: true,
                infinite: true
            }
        },
        {
            breakpoint: 991,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 2,
                infinite: true
            }
        },
        {
            breakpoint: 576,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                infinite: true
            }
        }
    ]
});
